function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PotTemplate = require('./pot.template');
var PotDetailsTemplate = require('./pot-details.template');
var SaitoOverlay = require('../../../../lib/saito/ui/saito-overlay/saito-overlay');
var Pot = /*#__PURE__*/function () {
  function Pot(app, mod) {
    _classCallCheck(this, Pot);
    this.app = app;
    this.game_mod = mod;
    this.pot_active = true;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(Pot, [{
    key: "render",
    value: function render() {
      var pot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      if (!this.game_mod.gameBrowserActive() && !this.game_mod.browser_active) {
        return;
      }
      if (pot == -1) {
        var _this$game_mod$game;
        pot = 0;
        if (this.pot_active && (_this$game_mod$game = this.game_mod.game) !== null && _this$game_mod$game !== void 0 && (_this$game_mod$game = _this$game_mod$game.state) !== null && _this$game_mod$game !== void 0 && _this$game_mod$game.player_pot) {
          for (var i = 0; i < this.game_mod.game.state.player_pot.length; i++) {
            pot += this.game_mod.game.state.player_pot[i];
          }
        }
      }
      if (!document.querySelector('.poker-pot')) {
        if (!this.ticker) {
          this.ticker = this.game_mod.returnTicker();
        }
        this.app.browser.addElementToSelector(PotTemplate(), '.poker-sidebar');
      }
      try {
        if (!this.pot_active) {
          document.querySelector('.poker-pot').classList.add('invisible');
        } else {
          document.querySelector('.poker-pot').classList.remove('invisible');
        }
        var l2 = document.querySelector('.poker-pot .line2');
        var l3 = document.querySelector('.poker-pot .line3');

        // Same CHIP ↔ crypto presentation helper as player boxes.
        if (l2) {
          l2.innerHTML = this.game_mod.returnChipCryptoBalanceHtml(pot);
        }
        if (l3) {
          l3.innerHTML = '';
          l3.hidden = true;
        }
      } catch (err) {
        console.error(err);
      }
      if (pot && !this.game_mod.animating) {
        this.attachEvents();
      }
      return pot;
    }
  }, {
    key: "activate",
    value: function activate() {
      this.pot_active = true;
    }
  }, {
    key: "clearPot",
    value: function clearPot() {
      this.pot_active = false;
      this.render(0);
    }
  }, {
    key: "addPulse",
    value: function addPulse() {
      if (document.querySelector('.poker-pot .line2')) {
        document.querySelector('.poker-pot .line2').classList.add('pulse');
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var potEl = document.querySelector('.poker-pot');
      if (!potEl) {
        return;
      }
      potEl.onclick = function (e) {
        // Balance flip handles its own click; still allow opening pot details otherwise.
        if (e.target.closest('.chip-crypto-balance--toggle')) {
          return;
        }
        _this.overlay.show(PotDetailsTemplate(_this.game_mod));
      };
    }
  }]);
}();
module.exports = Pot;